export * from './betting-mode-image';